import { ofType, combineEpics } from 'redux-observable';
import { map as rxmap } from 'rxjs/operators';
import { cx } from '../../../api';
import { actions as categoriesActions } from '../../api/categories';
import { ActionGeneratorBuilder } from '../../actions';

const ROOT_MNEMONICS = "employee";

const defaultState = {
	root: null,
	list: null,
	map: null,
	pending: false,
	error: null
};

const actions = new ActionGeneratorBuilder('employeeCategories')
	.subtype('add', add => add.request('data').success('data').fail())
	.subtype('load', load => load.request().success('root').fail())
	.subtype('update', update => update.request({ categoryId: true, data: true }).success().fail())
	.subtype('remove', remove => remove.request('categoryId').success().fail())
	.type('set', { root: true, categories: true, map: true })
	.type('clear')
	.build()
;

// ---------------------------------------------------------



function reducer(state = defaultState, action) {
	switch (action.type) {
		case actions.load.request.type:
			return {
				...state,
				pending: true,
				error: null
			};
		case categoriesActions.load.success.type:
			return {
				...state,
				pending: false
			}
		case categoriesActions.load.fail.type:
			return {
				...state,
				pending: false,
				error: action.errorMessage
			};
		case actions.set.type:
			return {
				...state,
				pending: false,
				root: action.root,
				list: action.categories,
				map: action.map
			};
		default:
			return state;
	}
}

// ---------------------------------------------------------

const filter = (categories) => {
	const root = categories.find(category => category.mnemonics == ROOT_MNEMONICS);
	const filtered = root ? categories.filter(category => category.comprisingIds && category.comprisingIds.indexOf(root.categoryId) >= 0) : [];
	filtered.sort((left, right) => {
		return left.name && right.name ? (left.name.toLowerCase() > right.name.toLowerCase()) : left.categoryId > right.categoryId;
	});
	return { root, categories: filtered, map: cx.i.hash(filtered, (category) => category.categoryId) };
}

const loadEpic = (action$) => {
	return action$.pipe(
		ofType(actions.load.request.type),
		rxmap(action => categoriesActions.load.request()),
	)
}

const addEpic = (action$) => {
	return action$.pipe(
		ofType(actions.add.request.type),
		rxmap(action => categoriesActions.add.request({ data: action.data }))
	)
}

const updateEpic = (action$) => {
	return action$.pipe(
		ofType(actions.update.request.type),
		rxmap(action => categoriesActions.update.request({ categoryId: action.categoryId, data: action.data }))
	)
}

const removeEpic = (action$) => {
	return action$.pipe(
		ofType(actions.remove.request.type),
		rxmap(action => categoriesActions.remove.request({ categoryId: action.categoryId }))
	)
}

const watchCategoriesLoadEpic = (action$, state$) => {
	return action$.pipe(
		ofType(categoriesActions.load.success.type),
		rxmap(action => actions.set(filter(state$.value.categories.general.list)))
	)
}

const epic = combineEpics(loadEpic, addEpic, updateEpic, removeEpic, watchCategoriesLoadEpic);

// ---------------------------------------------------------

export { actions, reducer, epic };
